var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.disabled,
                                  "data-testid": _vm.testId + "--estado"
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.proveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.proveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.proveedorGps.id,
                                  "data-testid": _vm.testId + "--proveedor-gps",
                                  items: _vm.formFields.proveedorGps.items,
                                  disabled: _vm.disabled || _vm.edicion,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value: _vm.formFields.proveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.proveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.proveedorGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.clienteProveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.clienteProveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.clienteProveedorGps.id,
                                  "data-testid":
                                    _vm.testId + "--cliente-proveedor-gps",
                                  items:
                                    _vm.formFields.clienteProveedorGps.items,
                                  disabled: _vm.disabled || _vm.edicion,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value:
                                    _vm.formFields.clienteProveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.clienteProveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.clienteProveedorGps.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Credenciales Conexión" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled &&
                                      "required|max:50|loginUnico",
                                    expression:
                                      "!disabled && 'required|max:50|loginUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.usuario.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.usuario.id
                                  ),
                                  "data-vv-name": _vm.formFields.usuario.id,
                                  "data-testid": _vm.testId + "--usuario",
                                  counter: 50,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.usuario.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuario,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuario.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("CampoContrasena", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required|max:50",
                                    expression: "!disabled && 'required|max:50'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.password.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.password.id
                                  ),
                                  "data-vv-name": _vm.formFields.password.id,
                                  "test-id": _vm.testId + "--contrasena",
                                  counter: 50,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.password.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.password,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.password.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Inicio de la Autorización" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                ref: "fechaInicio",
                                attrs: {
                                  label: _vm.formFields.fechaInicio.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaInicio.id
                                  ),
                                  id: _vm.formFields.fechaInicio.id,
                                  "test-id": _vm.testId + "--fecha-inicio",
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.fechaInicio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaInicio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaInicio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("TimePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horaInicio.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horaInicio.id
                                  ),
                                  id: _vm.formFields.horaInicio.id,
                                  "test-id": _vm.testId + "--hora-inicio",
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.horaInicio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horaInicio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horaInicio.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Fin de la Autorización" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled &&
                                      _vm.formFields.horaTermino.value &&
                                      "required|fechaTerminoMayor:fechaInicio",
                                    expression:
                                      "\n                  !disabled &&\n                    formFields.horaTermino.value &&\n                    'required|fechaTerminoMayor:fechaInicio'\n                "
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.fechaTermino.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaTermino.id
                                  ),
                                  id: _vm.formFields.fechaTermino.id,
                                  "test-id": _vm.testId + "--fecha-termino",
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.fechaTermino.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaTermino,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaTermino.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("TimePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled &&
                                      _vm.formFields.fechaTermino.value &&
                                      "required",
                                    expression:
                                      "\n                  !disabled && formFields.fechaTermino.value && 'required'\n                "
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horaTermino.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horaTermino.id
                                  ),
                                  id: _vm.formFields.horaTermino.id,
                                  "test-id": _vm.testId + "--hora-termino",
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.horaTermino.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horaTermino,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horaTermino.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled && "required|min_value:1",
                                    expression:
                                      "!disabled && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.maxConsultasPorDia.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.maxConsultasPorDia.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.maxConsultasPorDia.id,
                                  "data-testid":
                                    _vm.testId + "--max-consultas-dia",
                                  disabled: _vm.disabled,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.maxConsultasPorDia.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.maxConsultasPorDia,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.maxConsultasPorDia.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled && "required|min_value:1",
                                    expression:
                                      "!disabled && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.maxConsultasPorHora.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.maxConsultasPorHora.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.maxConsultasPorHora.id,
                                  "data-testid":
                                    _vm.testId + "--max-consultas-hora",
                                  disabled: _vm.disabled,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.maxConsultasPorHora.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.maxConsultasPorHora,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.maxConsultasPorHora.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled && "required|min_value:1",
                                    expression:
                                      "!disabled && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.maxRegistrosPorBloque.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.maxRegistrosPorBloque.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.maxRegistrosPorBloque.id,
                                  "data-testid":
                                    _vm.testId + "--max-registros-bloque",
                                  disabled: _vm.disabled,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.maxRegistrosPorBloque.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.maxRegistrosPorBloque,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.maxRegistrosPorBloque.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }